// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/mountain-wave-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/mountain-wave-hazards/mountain-wave-hazards.js';

mount([g0]);
